import { createZustandShallowStore } from '@/lib/zustand';
import { AuthenticateInfo } from '@/server/api/v1/auth/types';
import { SetStoreState } from '@/types/use';

/** This is the tatic to validate user auth info. It only take effect when using with AuthenticationResolverDialog
 * It will validate after ui being render so recommentded to use auth() for server side or useRequiredAuthenticate() for client side
 * for checking authentication
 * @see AuthenticationResolverDialog
 * @see auth for server side
 * @see useRequiredAuthenticate for client side
 */
export enum UnAuthenticationAction {
    pushLogin,
    modalLogin,
    recommendLogin,
    noAction,
}
interface UnAuthenticationInfoProps {
    action: UnAuthenticationAction;
    userName?: string;
}
interface AuthenticationStoreProps {
    /**Đã được xác thực */
    isAuthenticated: boolean;
    setIsAuthenticated: (isAuthenticated: boolean) => void;
    auth?: AuthenticateInfo;
    setAuth: SetStoreState<AuthenticateInfo | undefined>;

    unAuthInfo?: UnAuthenticationInfoProps;
    setUnAuthenticateInfo: (
        fn:
            | undefined
            | UnAuthenticationInfoProps
            | ((
                  t?: UnAuthenticationInfoProps
              ) => UnAuthenticationInfoProps | undefined)
    ) => void;
}

export const useAuthenticationStore =
    createZustandShallowStore<AuthenticationStoreProps>((set, get) => ({
        isAuthenticated: false,
        setIsAuthenticated(bool) {
            set({ isAuthenticated: bool });
        },

        setAuth(fn) {
            set((st) => {
                const authData = typeof fn === 'function' ? fn(st.auth) : fn;
                return {
                    auth: authData,
                };
            });
        },

        setUnAuthenticateInfo(fn) {
            set((state) => ({
                unAuthInfo:
                    typeof fn === 'function' ? fn(state.unAuthInfo) : fn,
            }));
        },
    }));
